var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('app-header'),_c('main'),_c('app-footer'),_c('scroll-to-top'),_c('loading-anim',{attrs:{"show":_vm.isLoading,"loaderColor":_vm.AppConst.LOADING.COLOR,"boxColor":_vm.AppConst.LOADING.BOXCOLOR}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }